<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.custom_list") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-3.col-2.mb-1(v-if="!isSubAccount")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.assignee') }}
                  b-form-select(v-model="assignee" size="sm" @change="getCpiMemberCustomList(true)")
                    option(value="") {{ $t('ui.all') }}
                    option(v-for="info in subAccountList" :value="info.login_id") {{ info.login_id }}
              .form-group.col-12.mb-1
                SubmitButton.mr-2(
                  :loading="loading"
                  :icon="!isSubAccount ? 'fa fa-search' : 'fa fa-sync'"
                  :text="!isSubAccount ? $t('ui.search') : $t('ui.refresh')"
                  type="button"
                  @click="getCpiMemberCustomList(true)"
                  variant="primary"
                  size="sm"
                )
                jsonToExcel(v-if="cpiMemberList.length > 0" mode="CPICustomList" tbl="tblList" :date="dateRange" btnTxt="export_one" type="1" :loading2="loading").mr-2
                cpiCustomListExport(v-if="cpiMemberList.length > 0" :isSubAccount="isSubAccount" :tbl="cpiMemberList" tblId="tblList")

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12 
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="9%")
                          span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                        th(width="9%")
                          span(:title="$t('ui.name')") {{ $t("ui.name") }}
                        th(width="9%")
                          span(:title="$t('ui.email')") {{ $t('ui.email') }}
                        th.text-center(width="14%" v-if="!isSubAccount")
                          span(:title="$t('ui.assignee')") {{ $t("ui.assignee") }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.urgency')") {{ $t("ui.urgency") }}
                        th(width="10%")
                          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                        th(width="10%")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                        th.text-center(width="8%" v-if="isEditAccess")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="cpiMemberList.length == 0")
                        td(:colspan="11").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in cpiMemberList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.phone") {{ item.phone }}
                        td
                          span(:title="item.fullname") {{ item.fullname }}
                        td
                          small.d-block(:title="item.email") {{ item.email }}
                          small.d-block(:title="item.email2") {{ item.email2 }}
                          small.d-block(:title="item.email3") {{ item.email3 }}
                        td.text-center(v-if="!isSubAccount")
                          template(v-if="isEditAccess")
                            b-form-select(v-model="item.login_id" @change="changedAssignee(item, $event)" size="sm" :disabled="loading")
                              option(v-for="info in subAccountList" :value="info.login_id") {{ info.login_id }}
                          template(v-else)
                            span(:title="item.login_id") {{ item.login_id }}
                        td.text-center
                          span(:title="item.status") {{ item.status }}
                        td.text-center
                          template(v-if="isEditAccess && !isSubAccount")
                            b-form-select.text-uppercase(v-model="item.urgency" @change="changedUrgency(item, $event)" size="sm" :disabled="loading")
                              option(:value="1") {{ $t("ui.urgency_1") }}
                              option(:value="2") {{ $t("ui.urgency_2") }}
                              option(:value="3") {{ $t("ui.urgency_3") }}
                          template(v-else)
                            span.text-uppercase(:title='$t("ui.urgency_" + item.urgency)' :class="getUrgencyBadgeClass(item.urgency)") {{ $t("ui.urgency_" + item.urgency) }}
                        td
                          span(:title="item.remark") {{ item.remark }}
                        td.text-right
                          template(v-if="item.created_on != null")
                            span.d-block(:title="item.created_by") {{ item.created_by }}
                            span.d-block(:title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          template(v-if="item.modified_on != null")
                            span.d-block(:title="item.modified_by") {{ item.modified_by }}
                            span.d-block(:title="$moment(item.modified_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_on).format('YYYY-MM-DD, HH:mm:ss') }}
                          span(v-else) -
                        td.text-center(v-if="isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

    editcustom(ref="editcustom" :customerInfo="selectedMember" @clicked="afterEditCustom" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import editcustom from "@/components/cpi/editCustom.vue";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import cpiCustomListExport from "@/components/cpi/cpiCustomListExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editcustom,
    jsonToExcel,
    cpiCustomListExport
  },
  data: () => ({
    loading: false,
    filterBy: "",
    cpiMemberList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "urgency",
    sortType: "desc",
    searchID: '',
    selectedMember: null,
    subAccountList: [],
    assignee: "",
    dateRange: {
      startDate: null,
      endDate: null
    }
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cpi");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isSubAccount() {
      if (this.getAuthorityRole == 'OWNER_PRI' || this.getAuthorityRole == 'OWNER_SEC') {
          return false;
      } else {
          return true;
      }
    }
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

      if(this.isOperator) {
        this.searchID = this.accountID
      }

      if(!this.isSubAccount)
        this.getSubAccountList();
      else
        this.getCpiMemberCustomList(true)
    }
  },
  methods: {
    getUrgencyBadgeClass(urgency) {
      var badgeClass = ''
      switch(urgency) {
        case 1:
          badgeClass = this.$helpers.badgeClass('LOW')
          break;
        case 2:
          badgeClass = this.$helpers.badgeClass('MODERATE')
          break;
        case 3:
          badgeClass = this.$helpers.badgeClass('HIGH')
          break;
      }
      return badgeClass
    },
    onGroupCall(e) {
      this.selectedMember = e;
      this.$refs.groupcall.$refs.groupCall.show();
    },
    afterGroupCall() {
      this.getCpiMemberCustomList();
      this.$helpers.showDialog(this.$t("ui.call"), this.$t("message.will_start_call_now"), "success");
    },
    onEdit(e) {
      this.selectedMember = e;
      this.$refs.editcustom.$refs.editCustom.show();
    },
    afterEditCustom() {
      this.getCpiMemberCustomList();
      this.$helpers.showDialog(this.$t("ui.edit_custom"), this.$t("message.success"), "success");
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getCpiMemberCustomList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getCpiMemberCustomList: function(isSearch) {
      this.selectedMember = null;
      let url = config.cpiMemberCustomListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.searchID,
        assignee: this.assignee,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiMemberList = response.data.dt;
                this.totalRow = this.cpiMemberList.length > 0 ? this.cpiMemberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getSubAccountList: function() {
      let url = config.accountSubListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: this.$store.getters.loginId,
        page_number: 1,
        page_size: 100
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subAccountList = response.data.dt;
                this.getCpiMemberCustomList(true);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getCpiMemberCustomList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getCpiMemberCustomList();
    },
    changedAssignee: function(info, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_cpi_custom_assignee_confirm", { name: info.phone }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAssignee(info, eventStatus);
          } else {
            this.getCpiMemberCustomList()
          }
        });
    },
    confirmAssignee: function(info, assignee) {
      let url = config.cpiMemberCustomMoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.searchID,
        phone: info.phone,
        target_account_id: assignee,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.assignee"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getCpiMemberCustomList()
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedUrgency: function(info, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_cpi_custom_urgency_confirm", { name: info.phone }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUrgency(info, eventStatus);
          } else {
            this.getCpiMemberCustomList()
          }
        });
    },
    confirmUrgency: function(info, urgency) {
      let url = config.cpiMemberCustomUrgencyUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.searchID,
        phone: info.phone,
        urgency: urgency,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.urgency"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getCpiMemberCustomList()
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete:function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.delete"),
          text: this.$t("message.delete_cpi_custom_confirm", { name: e.phone }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(e);
          }
        });
    },
    confirmDelete: function(e) {
      let url = config.cpiMemberCustomRemoveUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        account_id: this.searchID,
        phone: e.phone
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getCpiMemberCustomList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
